import React from "react";

import { Link } from "react-router-dom";

import { useGetApplicationQuery } from "../api";
import Chrome from "../components/Chrome";
import Layout from "../components/Layout";
import LoadingPage from "../components/LoadingPage";
import StripeSetupIntentWidget from "../components/StripeSetupIntentWidget";
import { additionalInformationURL, startURL } from "../urls";
import BodyText from "Cobalt/BodyText";
import { LinkButton } from "Cobalt/Button";
import { CardSection } from "Cobalt/Card";
import { H4 } from "Cobalt/Header";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";

const PaymentPage = () => {
  const { data: { benAdminLead } = {}, isLoading: isLoadingBenAdminLead } = useGetApplicationQuery();

  return isLoadingBenAdminLead ? (
    <LoadingPage />
  ) : (
    <Chrome>
      <Layout>
        <CardSection>
          <Link component={LinkButton} size="medium" to={startURL} color="link" pl={0} mb={3}>
            <Icon icon="chevron-left" pr={3} />
            Back
          </Link>
          <H4>Purchase Your Subscription</H4>
          <BodyText mt={4}>Once you are onboarded in SimplyInsured we will charge you $5 per employee per month.</BodyText>
          {benAdminLead?.stripeSetupComplete ? (
            <>
              <BodyText mt={4}>You are already subscribed!</BodyText>
              <Link component={LinkButton} to={additionalInformationURL} size="medium" my={4}>
                Next
              </Link>
            </>
          ) : (
            <Div pt={4}>
              <StripeSetupIntentWidget />
            </Div>
          )}
        </CardSection>
      </Layout>
    </Chrome>
  );
};

export default PaymentPage;
